import { tokens } from '@/locales/translations/tokens'
import { useTranslation } from 'react-i18next'
import { useUserStore } from '@/stores/userStore'
import { NavGroup } from '../../types'

interface useSidebarRenderingByFeaturesProps {
  filteredSidebarDataByPlanType: NavGroup[]
}

const useSidebarRenderingByFeatures = ({
  filteredSidebarDataByPlanType,
}: useSidebarRenderingByFeaturesProps) => {
  const { t } = useTranslation()
  const { userData } = useUserStore((state) => state.user)

  const organizationsFeatures = userData?.active_organization?.features || []

  const filteredSidebarDataByFeatures = (filteredSidebarDataByPlanType || []).map((group) => {
    const filteredItems = group.items
      .filter(
        (item) =>
          !item.features ||
          item.features.some((feature) =>
            organizationsFeatures.includes(feature)
          )
      )
      .map((item) => {
        if ('items' in item && item.items) {
          const filteredSubItems = item.items.filter(
            (subItem) =>
              !subItem.features ||
              subItem.features.some((feature) =>
                organizationsFeatures.includes(feature)
              )
          )
          return { ...item, items: filteredSubItems }
        }
        return item
      })
    return { ...group, items: filteredItems }
  })

  const mainNavGroups = (filteredSidebarDataByFeatures || []).filter(
    (group) => group.title === t(tokens.sidebar.section.general)
  )

  const footerNavGroups = (filteredSidebarDataByFeatures || []).filter(
    (group) => group.title === t(tokens.sidebar.section.other)
  )

  return {
    mainNavGroups,
    footerNavGroups,
  }
}

export default useSidebarRenderingByFeatures
